<template>
  <v-container class="shopStartPage">
    <side-navigation/>
    <scanner-dialog/>
    <cart-drawer/>
    <inventory-drawer/>
    <router-view/>
  </v-container>
</template>

<script>
import SideNavigation from "@/app/global/sideNavigation";
import CartDrawer from "@/app/cart/cartDrawer";
import ScannerDialog from "@/app/scanner/scannerDialog";
import InventoryDrawer from "@/app/inventory/inventoryDrawer";
export default {
name: "adminSkeleton",
  components: {InventoryDrawer, ScannerDialog, CartDrawer, SideNavigation}
}
</script>

<style scoped>

</style>
